import { connect } from "react-redux";
import SelfVsOtherPerception from "./SelfVsOtherPerception";


const mapStateToProps = (state) => ({
    fetchSelfVsOthersApi: state.BenchmarkFilteringReducer.fetchSelfVsOthersApi,
    fetchDistributionStripApi: state.BenchmarkFilteringReducer.fetchDistributionStripApi,
});

const mapDispatchToProps = (dispatch) => ({




});

export default connect(mapStateToProps, mapDispatchToProps)(SelfVsOtherPerception);
